const experimentationRouter = [
  {
    path: '/experimentation',
    name: 'Experimentation',
    component: () => import('../../views/experimentation/index.vue'),
    meta: '实验首页',
    children: [
      {
        path: '/experimentation/test',
        name: 'test',
        component: () => import('../../views/experimentation/test/index.vue'),
        meta: {
          title: '理论测试'
        }
      },
      {
        path: '/experimentation/report',
        name: 'report',
        component: () => import('../../views/experimentation/test/report.vue'),
        meta: {
          title: '实验报告'
        }
      },
      // 实验1
      {
        path: '/experimentation/experimentation1',
        name: 'experimentation1',
        component: () => import('../../views/experimentation/experimentation/experimentation1/index.vue'),
        meta: {
          title: '妈祖信仰与泉州天后宫'
        }
      },
      // 实验2
      {
        path: '/experimentation/experimentation2',
        name: 'experimentation2',
        component: () => import('../../views/experimentation/experimentation/experimentation2/index.vue'),
        meta: {
          title: '传统建筑设计与构造教学'
        }
      },
      // 实验3
      {
        path: '/experimentation/experimentation3',
        name: 'experimentation3',
        component: () => import('../../views/experimentation/experimentation/experimentation3/components/InteractiveOne.vue'),
        meta: {
          title: '闽南侨乡传统建筑构造'
        }
      },
    ]
  },
  {
    path: '/experimentation/experimentation3/Interactive1',
    name: 'experimentation3-Interactive1',
    component: () => import('../../views/experimentation/experimentation/experimentation3/components/InteractiveOne.vue'),
    meta: {
      title: '闽南侨乡传统建筑构造'
    }
  },
  {
    path: '/experimentation/experimentation2/InteractiveFramework',
    name: 'experimentation2-Interactive2',
    component: () => import('../../views/experimentation/experimentation/experimentation2/components/InteractiveFramework.vue'),
    meta: {
      title: '传统木架构实验'
    }
  },
  {
    path: '/experimentation/experimentation2/InteractiveRoof',
    name: 'experimentation2-Interactive4',
    component: () => import('../../views/experimentation/experimentation/experimentation2/components/InteractiveRoof.vue'),
    meta: {
      title: '传统屋顶实验'
    }
  },
  {
    path: '/experimentation/experimentation2/InteractiveGround',
    name: 'experimentation2-Interactive5',
    component: () => import('../../views/experimentation/experimentation/experimentation2/components/InteractiveGround.vue'),
    meta: {
      title: '传统地面实验'
    }
  },
  {
    path: '/experimentation/experimentation2/InteractiveWall',
    name: 'experimentation2-Interactive3',
    component: () => import('../../views/experimentation/experimentation/experimentation2/components/InteractiveWall.vue'),
    meta: {
      title: '传统墙体实验'
    }
  },
  {
    path: '/experimentation/experimentation2/InteractiveAll',
    name: 'experimentation2-Interactiveqd',
    component: () => import('../../views/experimentation/experimentation/experimentation2/components/InteractiveAll.vue'),
    meta: {
      title: '整体实验'
    }
  },
  {
    path: '/experimentation/experimentation2/InteractiveRoofTest',
    name: 'experimentation2-Interactive4kh',
    component: () => import('../../views/experimentation/test/InteractiveRoofTest.vue'),
    meta: {
      title: '传统屋顶实验考核'
    }
  },
]

export default experimentationRouter